module.exports = __webpack_public_path__ + "img/metaLoginImgNew.8fd312c7.svg";